import React from 'react';
import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail';
import $STP from 'plugins/tfs/platformConfigs/staticTextMaps/printableArea';
import moment from 'moment';

const PrintableView = ({ packageOrder = {} }) => {
  const {
    orderNumber,
    orderNotes,
    packageItemSet = [],
    shippingAddress = {},
    deliveryRange = {},
  } = packageOrder;
  const {
    customerName,
    customerSurname,
    line,
    city,
    district,
    township,
    country,
  } = shippingAddress;
  const { lower, upper } = deliveryRange;
  const padding5 = { padding: '5px' };
  const verticalAlign = { verticalAlign: 'top' };
  const tableLayout = {
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  let defaultUnitWeight = 0;
  let formattedPrice = 0;

  const formattedPackageItemSet = packageItemSet.reduce((acc, curr) => {
    const {
      unit_weight,
      orderItem: {
        attributes,
        price,
        currency = '',
        product: { name, sku } = {},
      } = {},
    } = curr;
    let key = sku;
    if (!acc[key]) {
      acc[key] = [];
    }

    let enteredUnitWeight = 0;
    if (unit_weight) {
      const _arr = packageItemSet.filter(
        (item) => item.orderItem.product.sku === sku
      );
      for (let i in _arr) {
        enteredUnitWeight += parseFloat(_arr[i].unit_weight);
      }
    }

    acc[key].push({
      enteredUnitWeight,
      attributes,
      sku,
      name,
      price,
      currency,
      count: acc[key].length + 1,
    });
    return acc;
  }, {});

  let totalPrice = 0;
  let totalCount = 0;
  let curr;

  return (
    <div>
      <h1 style={{ textAlign: 'center' }}>{$STP.PRINT_HEAD}</h1>
      <table style={tableLayout}>
        <tr>
          <td style={{ ...verticalAlign }}>
            <strong>{$ST.ORDER_NUMBER_SHORT}:</strong>
          </td>
          <td style={{ ...verticalAlign }}>{orderNumber}</td>

          <td style={{ ...verticalAlign }}>
            <strong>{$ST.ADDRESS}:</strong>
          </td>
          <td>
            <div
              style={{
                width: '200px',
                display: 'grid',
                gap: '2px',
              }}
            >
              <span>{district}</span>
              <span>{line.split($ST.SEPERATOR).join($ST.CONCATENATOR)}</span>
              <span>{city}</span>
              <span>{township}</span>
              <span>{country}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <strong>{$ST.CUSTOMER}:</strong>
          </td>
          <td>{`${customerName} ${customerSurname}`}</td>

          <td>
            <strong>{$ST.DELIVERY_HOURS}:</strong>
          </td>
          <td>
            {moment(lower).format('HH:mm')} - {moment(upper).format('HH:mm')}
          </td>
        </tr>
        <tr>
          <td>
            <strong>{$ST.DELIVERY_DATE}:</strong>
          </td>
          <td>{moment(lower).format('Do MMMM YYYY, dddd')}</td>

          <td>
            <strong>{$ST.ORDER_NOTES}:</strong>
          </td>
          <td>
            <div style={{ width: '200px', fontWeight: 'bold' }}>
              {orderNotes || '-'}
            </div>
          </td>
        </tr>
      </table>
      <br />
      <h3 style={{ ...tableLayout, marginBottom: 0 }}>
        {$STP.DELIVERED_PRODUCTS_TITLE}
      </h3>
      <table style={{ borderCollapse: 'collapse', ...tableLayout }} border='1'>
        <tr>
          <th style={{ padding: '5px', textAlign: 'left' }}>{$STP.NO}</th>
          <th style={{ padding: '5px', textAlign: 'left' }}>
            {$STP.PRODUCT_NAME}
          </th>
          <th style={{ padding: '5px', textAlign: 'left' }}>{$STP.SKU}</th>
          <th style={{ padding: '5px', textAlign: 'left' }}>{$STP.QUANTITY}</th>
          <th style={{ padding: '5px', textAlign: 'left' }}>
            {$STP.WEIGHT} ({$STP.WEIGHT_TYPE})
          </th>
          <th style={{ padding: '5px', textAlign: 'left' }}>
            {$STP.UNIT_PRICE}
          </th>
          <th style={{ padding: '5px', textAlign: 'left' }}>
            {$STP.TOTAL_PRICE}
          </th>
        </tr>
        {Object.keys(formattedPackageItemSet).map((key, i) => {
          const {
            name,
            sku,
            price,
            currency,
            count,
            attributes,
            enteredUnitWeight,
          } =
            formattedPackageItemSet[key][
              formattedPackageItemSet[key].length - 1
            ];

          totalCount += count;
          curr = currency;

          defaultUnitWeight =
            attributes.unit_weight && parseFloat(attributes.unit_weight) > 0
              ? attributes.unit_weight
              : 1;

          if (defaultUnitWeight && enteredUnitWeight) {
            formattedPrice = parseFloat(
              (enteredUnitWeight / defaultUnitWeight) * price
            ).toFixed(2);
          } else {
            formattedPrice = parseFloat(price * count).toFixed(2);
          }

          totalPrice += parseFloat(formattedPrice);

          return (
            <tr key={i}>
              <td style={{ padding: '5px', fontWeight: 'bold' }}>{i + 1}</td>
              <td style={{ padding: '5px', minWidth: '350px' }}>{name}</td>
              <td style={padding5}>{sku}</td>
              <td style={padding5}>{count}</td>
              <td style={padding5}>{enteredUnitWeight || '-'}</td>
              <td style={padding5}>
                {parseFloat(price).toFixed(2).replace(/\./g, ',')}{' '}
                {currency.toLocaleUpperCase()}
              </td>
              <td style={padding5}>
                {formattedPrice.replace(/\./g, ',')}{' '}
                {currency.toLocaleUpperCase()}
              </td>
            </tr>
          );
        })}
        <tr>
          <td
            colSpan='3'
            style={{ textAlign: 'left', fontWeight: 'bold', padding: '5px' }}
          >
            {$STP.TOTAL}
          </td>
          <td style={{ padding: '5px', fontWeight: 'bold' }}>{totalCount}</td>
          <td style={{ padding: '5px', fontWeight: 'bold' }}></td>
          <td style={{ padding: '5px', fontWeight: 'bold' }}></td>
          <td style={{ padding: '5px', fontWeight: 'bold' }}>
            {parseFloat(totalPrice).toFixed(2).replace(/\./g, ',')}{' '}
            {curr.toLocaleUpperCase()}
          </td>
        </tr>
      </table>
      <p style={{ ...tableLayout, letterSpacing: '0.5' }}>
        {$STP.INFO_MESSAGE}
      </p>
    </div>
  );
};

export default PrintableView;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/printableView/index.js